(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_groups/banner-game-promotions/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_groups/banner-game-promotions/assets/javascripts/render-component.js');
"use strict";



const isServer = typeof exports === 'object';

const getLogger = isServer ? require('@svenskaspelab/trinidad-core').core.logger : svs.core.log.getLogger;
const logger = getLogger('banner-groups: banner-game-promotions');

async function renderComponent(widgetData, widgetInfo, req, res) {
  const _widgetData$config = widgetData.config,
    widgetId = _widgetData$config.widgetId,
    title = _widgetData$config.title,
    subTitle = _widgetData$config.subTitle,
    layout = _widgetData$config.layout,
    minCountDummy = _widgetData$config.minCountDummy,
    _isMobile = _widgetData$config.isMobile,
    backgroundColor = _widgetData$config.backgroundColor;
  const _renderSingleBannerItem = async (bannerItem, index) => {
    const id = bannerItem.id,
      layoutType = bannerItem.layoutType;
    const pos = index + 1;
    try {
      if (!layoutType) {
        logger.warn("Banner with ID ".concat(id, " lacks layoutType property"));
        return '';
      }
      const _ref = isServer ? widgetData.components["banner_layouts/".concat(layoutType)] :
        svs.banner_layouts[layoutType.replace(/-/g, '_')],
        renderAsync = _ref.renderComponent;
      const bannerHtml = await renderAsync(bannerItem, widgetInfo, pos, req, res);
      return bannerHtml;
    } catch (error) {
      logger.warn("Grid banner with ID ".concat(id, " skipped due to banner loading error: ").concat(error.toString()), req);
      return '';
    }
  };
  const renderedBanners = await Promise.all(widgetData.banners.map(_renderSingleBannerItem));
  const childElements = renderedBanners.filter(Boolean);
  const isDesktop = isServer ? req.capabilities.formFactor === 'desktop' : svs.core.detect.formfactor.desktop();
  const isGrid = isDesktop && childElements.length < 4;
  const model = {
    widgetId,
    title,
    subTitle,
    layout,
    childElements,
    _isMobile,
    _hasEnoughChildren: childElements.length >= (minCountDummy || 3),
    backgroundColor,
    isDesktop,
    isGrid
  };
  return getCompiledTemplate('grid')(model) || '';
}

function getCompiledTemplate(name) {
  if (isServer) {
    return global.internalInstances.get('hbs').cache["components-banner_groups-banner_game_promotions-".concat(name)];
  }
  return svs.banner_groups.banner_game_promotions.templates[name];
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  setGlobal('svs.banner_groups.banner_game_promotions', {
    renderComponent
  });
}

 })(window);